import _util from '../../utils/';

const dailyReportService = {
	initDailyReport(gets, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReport/Post',
			params: gets,
			success: resolve,
			error: reject
		})
	},
	saveDailyReport(posts, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReport/Post',
			method: 'post',
			data: posts,
			success: resolve,
			error: reject
		})
	},
	fetchDailyReportList(gets, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReport/Get',
			params: gets,
			success: resolve,
			error: reject
		})
	},
	updateDailyReport(puts, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReport/SubmitReport',
			method: 'put',
			data: puts,
			success: resolve,
			 error: reject  
		})
	},
	copyDailyReport(gets, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReport/CopyReport',
			params: gets,
			success: resolve,
			error: reject
		})
	},
	fetchDailyReportDetail(gets, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReport/Details',
			params: gets,
			success: resolve,
			error: reject
		})		
	},
	multiDeleteDailyReport(deletes, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReport/Delete',
			method: 'delete',
			data: deletes,
			success: resolve,
			error: reject
		})			
	},
	submitDailyReport(puts, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReport/SubmitReport',
			method: 'put',
			data: puts,
			success: resolve,
			error: reject
		})		
	},
	emailRetryDailyWorkReport(params, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReport/EmailRetryDailyReport',
			params: params,
			success: resolve,
			error: reject
		})		
	},
	fetchLeaderDailyReportList(params, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportDailyManagement/Get',
			params: params,
			success: resolve,
			error: reject
		})			
	},
	fetchLeaderDailyReportDetail(params, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportDailyManagement/Details',
			params: params,
			success: resolve,
			error: reject
		})			
	},
	replyDailyReport(posts, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportReply/Post',
			method: 'post',
			data: posts,
			success: resolve,
			error: reject
		})	
	},
	multiNotifyDailyReport(posts, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportDailyManagement/SendNotification',
			method: 'post',
			data: posts,
			success: resolve,
			error: reject
		})	
	},

	confirmDateAllow(params, resolve, reject){
		_util.request({
			url: '/api/HRWorkReportDailyManagement/ConfirmDateAllow',
			params: params,
			success: resolve,
			error: reject
		})	
	}
}

export default dailyReportService




// WEBPACK FOOTER //
// ./src/services/WorkReport/daily-report-service.js